import { PropsWithChildren } from "react";
import styles from "./Accordion.module.css";

export default function Accordion(props: PropsWithChildren) {
    return <ul className={styles.accordion}>
        {props.children}
    </ul>
}
